export const EPUBJS_VERSION = "0.3";

// Dom events to listen for
export const DOM_EVENTS = ["keyup", "keypressed", "mouseup", "mousedown", "mousemove", "click", "dblclick", "touchend", "touchcancel", "touchstart", "touchmove", "wheel", "mousewheel", "DOMMouseScroll"];

export const BODY_EVENTS = [ "contextmenu" ];

export const MEDIA_EVENT = [ "play", "pause", "seeking", "volumechange", "ratechange", "ended", "error", "enterpictureinpicture", "leavepictureinpicture", "webkitfullscreenchange", "mozfullscreenchange", "fullscreenchange", "webkitbeginfullscreen", "webkitendfullscreen"];


export const EVENTS = {
  BOOK : {
    OPEN_FAILED : "openFailed"
  },
  CONTENTS : {
    EXPAND : "expand",
    RESIZE : "resize",
    SELECTED : "selected",
    SELECTED_RANGE : "selectedRange",
    LINK_CLICKED : "linkClicked",
    BOOKSSELECTED : "booksSelected",
    SWIP_LEFT : "swipLeft",
    SWIP_RIGHT : "swipRight",
    BOOK_FINISH : "bookFinish",
    SCROLL : "scroll",
    ZOOM : "zoom",
    ZOOM_TAP : "zoomTap",
    WAKE_SELECTION_CONTROLLER : "wakeSelectionController"
  },
  LOCATIONS : {
    CHANGED : "changed",
    GEN_PAGE_START : "genPageStart",
    GEN_PAGE_PROGRESS : "genPageProgress",
    GEN_PAGE_END : "genPageEnd",
    GEN_PAGE_ERROR : "genPageError",
    GEN_TTS_START : "genTTSStart",
    GEN_TTS_PROGRESS : "genTTSProgress",
    GEN_TTS_END : "genTTSEnd",
    GEN_TTS_ERROR : "genTTSError",
    GET_SEARCH_MATCHES : "getSearchMatches",
    SEARCH_COMPLETE: "searchComplete",
    STOP_SEARCH: "stopSearch",
    GET_CPCT_CFI: "getCpctCFI"
  },
  MANAGERS : {
    RESIZE : "resize",
    RESIZED : "resized",
    ORIENTATION_CHANGE : "orientationchange",
    ADDED : "added",
    START_SCROLL : "startScroll",
    SCROLL : "scroll",
    SCROLLED : "scrolled",
    REMOVED : "removed",
    RESIZED_DISPLAY: "resizedDisplay",
    CONTENT_SCALE: "contentScale"
  },
  VIEWS : {
    AXIS: "axis",
    WRITING_MODE: "writingMode",
    LOAD_ERROR : "loaderror",
    RENDERED : "rendered",
    RESIZED : "resized",
    DISPLAYED : "displayed",
    SHOWN : "shown",
    HIDDEN : "hidden",
    MARK_CLICKED : "markClicked",
    MARK_MOUSE_DOWN : "markMouseDown",
    MARK_MOUSE_UP : "markMouseUp",
    GET_SECTION_RENDER: "getSectionRender",
    WAKE_SELECTION_CONTROLLER : "wakeSelectionController"
  },
  RENDITION : {
    STARTED : "started",
    ATTACHED : "attached",
    DISPLAYED : "displayed",
    DISPLAY_ERROR : "displayerror",
    RENDERED : "rendered",
    REMOVED : "removed",
    RESIZED : "resized",
    ORIENTATION_CHANGE : "orientationchange",
    LOCATION_CHANGED : "locationChanged",
    RELOCATED : "relocated",
    ALLLOCATED : "allLocated",
    NOWBOOKMARK : "nowBookmark",
    GETCACULATELOCATION : "getCaculateLocation",
    MARK_CLICKED : "markClicked",
    SELECTED : "selected",
    BOOKSSELECTED : "booksSelected",
    LAYOUT: "layout",
    LOAD_SECTION : "loadSection",
    LAYOUT_END: "layoutEnd",
    GEN_PAGE_START : "genPageStart",
    GEN_PAGE_PROGRESS : "genPageProgress",
    GEN_PAGE_END : "genPageEnd",
    GEN_PAGE_ERROR : "genPageError",
    GEN_TTS_START : "genTTSStart",
    GEN_TTS_PROGRESS : "genTTSProgress",
    GEN_TTS_END : "genTTSEnd",
    GEN_TTS_ERROR : "genTTSError",
    CHANGE_BOOK_DIRECTION : "changeBookDirection",
    CHANGE_READ_SETTING : "changeReadSetting",
    SWIP_LEFT : "swipLeft",
    SWIP_RIGHT : "swipRight",
    BOOK_FINISH : "bookFinish",
    POP_IMAGE : "popImage",
    OPEN_VIDEO_PLAYER : "openVideoPlayer",
    OPEN_AUDIO_PLAYER : "openAudioPlayer",
    CONTROL_MEDIA : "controlMedia",
    POP_WINDOW : "popWindow",
    GET_SEARCH_MATCHES : "getSearchMatches",
    SEARCH_COMPLETE: "searchComplete",
    STOP_SEARCH: "stopSearch",
    CLEAR_RANGE: "clearRange",
    GET_CPCT_CFI: "getCpctCFI",
    CONTENT_SCALE: "contentScale",
    APPEND_ITEM: "appendItem",
    DELETE_ITEM: "deleteItem",
    RESIZE_ITEM: "resizeItem",
    START_SCROLL : "startScroll",
    START_PINCH_ZOOM : "startPinchZoom",
    STOP_PINCH_ZOOM : "stopPinchZoom",
    WAKE_SELECTION_CONTROLLER : "wakeSelectionController"
  },
  LAYOUT : {
    UPDATED : "updated"
  },
  ANNOTATION : {
    ATTACH : "attach",
    DETACH : "detach"
  }
}
